import Dialog from '@crochik/pi-react/services/Dialog';
import App from '@crochik/pi-react/application/App';

async function cancelAppointment(context: string) {
    // console.log('cancel appointments');
    // await api().cancelAppointment();
    // App().selectPage('CancelledAppointment', 'Cancelled', null);
    throw new Error('Not implemented');
}

export function cancel(context: string) {
    Dialog.confirm({
        title: 'Cancel Appointment?',
        message: 'Are you sure you would like to cancel this appointment?',
        onPositive: () => cancelAppointment(context),
        positiveCaption: 'Yes',
        negativeCaption: 'No',
    });
}

export function keep(context: string) {
    console.log('keep appt');
    let args = App().args;
    App().selectPage('Confirmation', context, args[1][0]);
}



// WEBPACK FOOTER //
// ./src/app/actions/Appointment.ts